<div class="layout-breadcrumb">
  <ul>
    <li><a routerLink=""><i class="pi pi-home"></i></a></li>
    <li>/</li>
    @for (item of items; track item; let last = $last) {
      <li>
        @if (item.routerLink) {
          <a [routerLink]="item.routerLink">{{item.label | translate}}</a>
        }
        @if (!item.routerLink) {
          {{item.label | translate}}
        }
      </li>
      @if (!last) {
        <li>/</li>
      }
    }
  </ul>

  <div class="layout-breadcrumb-options">
    <a routerLink="/" title="Backup">
      <i class="pi pi-cloud-upload"></i>
    </a>
    <a routerLink="/" title="Bookmark">
      <i class="pi pi-bookmark"></i>
    </a>
    <a routerLink="/" title="Logout">
      <i class="pi pi-power-off"></i>
    </a>
  </div>
</div>
